import {FaArrowLeft} from "react-icons/fa";
import { FaAngleRight } from "react-icons/fa6";
import {ChangeEvent, useRef} from "react";
import FrameButton from "@/components/buttons/FrameButton";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {useGetNftOwnerships} from "@/hooks/useGetNftOwnerships";
import {Token, UsersApi} from "@devour/client";
import GoFrensNftCard from "@/components/goFrens/GoFrensNftCard";
import {omit} from "lodash";
import getConfig from "@/utils/getConfig";
import {addError, decrementLoading, incrementLoading, updateCurrentUser} from "@/redux/meta/metaActions";
import {useGetUserProfile} from "@/hooks/useGetUserProfile";

interface Props {
    setShowPfpOptions: (val: boolean) => void;
    uploadPhoto: (e: ChangeEvent) => void;
}
export default function EditProfilePicture(props: Props) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: nftOwnershipsData} = useGetNftOwnerships(fullToken as Token);
    const inputRef = useRef<HTMLInputElement>(null);
    const dispatch = useDispatch();

    const {refetch: refetchUserProfile} = useGetUserProfile(fullToken);

    const nftOwnershipsWithCompleteUri = nftOwnershipsData?.nftOwnerships?.filter((ownership) => ownership?.tokenUri && ownership.tokenUri.length);

    async function handleAddNftAsPfp(nftID: string) {
        dispatch(incrementLoading());
        try {
            await new UsersApi(getConfig(fullToken)).updateProfilePicture({
                updateProfilePictureBody: {
                    nftID,
                },
            });
            const userRes = await new UsersApi(getConfig(fullToken)).getProfile();
            dispatch(updateCurrentUser(userRes));
            await refetchUserProfile();
            props.setShowPfpOptions(false);
        } catch (e) {
            dispatch(await addError(e));
        } finally {
            dispatch(decrementLoading());
        }
    }

    function renderEmptyState() {
        return (
            <div className="edit-profile-picture-modal_body_no-nfts">
                <div className="edit-profile-picture-modal_body_no-nfts_text">
                    <h5>No Available GoFriends NFT</h5>
                    <p>It looks like you don't own any GoFriends NFT at this moment.</p>
                </div>
                <div className="edit-profile-picture-modal_body_no-nfts_industry-pass">
                    <div className="edit-profile-picture-modal_body_no-nfts_industry-pass_text">
                        <h5>Get started with Industry Pass</h5>
                        <p>Unlock a world of exclusive benefits and utility with DevourGo!</p>
                    </div>
                    <div className="edit-profile-picture-modal_body_no-nfts_industry-pass_banner">
                        <img
                            src={import.meta.env.VITE_CDN_URL + "/images/GoFrens-IndustryPass-Promo.webp"}
                            alt="Industry Pass Promo"
                        />
                    </div>
                    <FaAngleRight />
                </div>
            </div>
        );
    }
    return (
        <>
            <div className="edit-profile-modal_header change-picture-header">
                <button
                    className="edit-profile-modal_header_icon"
                    onClick={() => props.setShowPfpOptions(false)}
                >
                    <FaArrowLeft
                        className="frame-one-bottom-panel_header_title-row_close-icon"
                    />
                </button>
                <h5>Change profile picture</h5>
            </div>
            <div className="edit-profile-picture-modal_body">
                <div className="edit-profile-picture-modal_body_upload">
                    <input
                        {...omit(props, "className", "isOpen", "onClose", "onProfilePictureUpdate")}
                        value={undefined}
                        ref={inputRef}
                        type="file"
                        className="edit-profile-modal_body_content_text_input"
                        onChange={e => props.uploadPhoto(e)}
                    />
                    <FrameButton
                        color="purple"
                        size="normal"
                        className="edit-profile-picture-modal_body_upload_btn"
                        onClick={() => inputRef?.current?.click()}
                    >
                        Upload from device
                    </FrameButton>
                </div>
                <div className="edit-profile-picture-modal_body_divider">OR</div>
                {nftOwnershipsData?.nftOwnerships?.length
                    ? <div className="edit-profile-picture-modal_body_nfts">
                        <h5>Choose a GoFriends NFT you own</h5>
                        <div className="edit-profile-picture-modal_body_nfts_container">
                            {nftOwnershipsWithCompleteUri.map(nft => <GoFrensNftCard
                                key={nft.id}
                                ownership={nft}
                                className="pfp-option"
                                onClick={() => handleAddNftAsPfp(nft.id)}
                            />)
                            }
                        </div>
                    </div>

                    : renderEmptyState()
                }
            </div>
        </>
    );
}